import { Article } from '@thro-types/billing';

import { TFunction } from 'i18next';
import * as yup from 'yup';

import { translations } from 'locales/i18n';

export const articleSettingsValidationSchema = (t: TFunction<'translation', undefined>) =>
  yup.object().shape({
    name: yup
      .string()
      .max(50, t(translations.validation.max(), { max: 50 }))
      .required(t(translations.validation.required()))
      .trim(),
    description: yup.string().required(t(translations.validation.required())).trim(),
    unit: yup.string().required(t(translations.validation.required())),
    price: yup.number().required(t(translations.validation.required())),
    defaultTaxId: yup.string().required()
  });

export const articleSettingsInitialValue = (initialArticle: Article) => {
  return {
    sku: initialArticle.sku,
    name: initialArticle.name,
    description: initialArticle.description,
    unit: initialArticle.unit,
    price: initialArticle.price,
    defaultTaxId: initialArticle.defaultTaxId
  };
};
